import { Routes } from '@angular/router';

export const routes: Routes = [
	{
		path: '',
		redirectTo: 'blog',
		pathMatch: 'full'
	},
	{
		path: 'blog',
		loadChildren: () => import('./blogs/blogs.routes').then(mod => mod?.blogsRoutes)
	},
	{
		path: '404',
		loadComponent: () => import('./page-not-found/page-not-found.component').then(mod => mod?.PageNotFoundComponent),
	},
	{
		path: '**',
		loadComponent: () => import('./page-not-found/page-not-found.component').then(mod => mod?.PageNotFoundComponent),
	}
];
